import type { PutApiV1ThreeLetterCodeClientAdminsUsersIdBody } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date';
import type { EditUserFormValues } from '../schema';

type Args = {
  formValues: EditUserFormValues;
};

/**
 * フォームの値から PUT リクエストボディを生成する
 */
export const generatePutRequestBody = ({
  formValues,
}: Args): PutApiV1ThreeLetterCodeClientAdminsUsersIdBody => ({
  user: {
    full_name: formValues.fullName,
    email: formValues.email,
    branch_id: formValues.branchId ? Number(formValues.branchId) : null,
    billable_from: formatDate({ date: formValues.billableFrom, formatType: 'yyyy-MM-dd' }),
  },
});
